import { Callout } from '@liveauctioneers/hammer-ui-core/callout';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';

import { ShippingMethods } from '@/enums/shippingMethod';
import { useAppSelector } from '@/redux/hooks';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getSellerName } from '@/redux/modules/seller';
import { getSellerUrl } from '@/utils/urls';

import { getShippingTypeMessageId } from './helpers/getShippingTypeMessageId';

type PaymentProcessedNotificationProps = {
    houseId: number;
    shippingMethod: ShippingMethods;
};

export const PaymentProcessedNotification = ({ houseId, shippingMethod }: PaymentProcessedNotificationProps) => {
    const email = useAppSelector(getBidderEmail);
    const houseName = useAppSelector((state) => getSellerName(state, houseId));
    const houseUrl = getSellerUrl(houseId, houseName);
    const messageTranslationId = getShippingTypeMessageId(shippingMethod);

    return (
        <div className="mt-lg">
            <Callout
                message={
                    <FormattedMessage
                        id={messageTranslationId}
                        values={{
                            email: <b key="bold-email">{email}</b>,
                            house: (
                                <Link
                                    key="checkout-payment-processed-house-link"
                                    href={houseUrl}
                                    size="sm"
                                >
                                    {houseName}
                                </Link>
                            ),
                        }}
                    />
                }
                status="success"
            />
        </div>
    );
};
